module.exports = __webpack_public_path__ + "static/media/team-member1.3f56e601.png";